import { createGlobalStyle } from 'styled-components';


export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  :root {
    --light-blue: rgb(3, 191, 202);
    --dark-blue: rgb(33, 80, 141);
    --light-green: #A1C95D;
    --white: #FBFBFB;
    --light-gray: #EEEEEE;
    --gray-background: #F2F2F2;
    --gray: #9C9C9C;
    --gray-100: #ced4da;
    --gray-200: #AFB2B1;
    --gray-500: #808080;
    --gray-800: #212529;
  }

  @media (max-width: 1080px) {
    html {
      font-size: 93.75%;
    }
  }

  @media (max-width: 720px) {
    html {
      font-size: 87.5%;
    }
  }

  @keyframes fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes bounce {
	0%, 100%, 20%, 50%, 80% {
		-webkit-transform: translateY(0);
		-ms-transform:     translateY(0);
		transform:         translateY(0)
	}
	40% {
		-webkit-transform: translateY(-10px);
		-ms-transform:     translateY(-10px);
		transform:         translateY(-10px)
	}
	60% {
		-webkit-transform: translateY(-5px);
		-ms-transform:     translateY(-5px);
		transform:         translateY(-5px)
	}
}

  body {
    font-family: 'Roboto', sans-serif;

  }

  body, input, textarea, button {
    color: var(--gray-800);
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
  }

  h1 {
    font-size: 2rem;
  }

  h2 {
    font-size: 1.5rem;
  }

  button {
    cursor: pointer;
  }

  .active {
    svg {
      transform: rotate(-180deg);
    }
  }

  .default-bnt {
    background-color: var(--light-blue);
    color: white;
    border: var(--light-blue);
    padding: 0.5rem 1rem;
    font-size: 1rem;
    border-radius: 0.3rem;
    -webkit-box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
      -moz-box-shadow: rgba(0,0,0,0.3) 0 1px 3px;
      box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
  }

  .scroll-body {
    max-width: 1400px;
    margin: 0 auto;
    &::-webkit-scrollbar{
      width: 7px;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px var(--light-blue);
      -webkit-box-shadow:  0 0 6px  transparent; 
      border-radius: 10px;
      max-height: 100px;
      height: 100%;

    }

    &::-webkit-scrollbar-thumb {
      box-shadow: inset 0 0 6px var(--light-blue);
      border-radius: 20px;
      -webkit-box-shadow: inset 40px 0 6px var(--light-blue); 
      max-height: 50px;
      height: 100%;
    }
  }
  
  body, html, #root {
    height: 100vh;
    width: 100vw;
    overflow-x: hidden;
    background: var(--gray-background);

  }

`;